import React from 'react';
import {
  mergeClasses,
  makeStyles,
  shorthands,
  tokens,
} from '@fluentui/react-components';

import { SaveButton, CancelButton, PreviewButton } from './buttons';

const useBasicFooterStyles = makeStyles({
  footer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    ...shorthands.gap('8px'),
    '& button': {
      minWidth: 'fit-content',
    },
  },
});

interface BasicFooterProps {
  saveButtonText?: string;
  saveDisabled?: boolean;
  cancelButtonText?: string;
  classes?: {
    root?: string;
  };
}

export const BasicFooter: React.FC<BasicFooterProps> = (props) => {
  const {
    saveButtonText,
    saveDisabled,
    cancelButtonText,
  } = props;
  const classes = useBasicFooterStyles();

  return (
    <div className={mergeClasses('basic-form-footer', classes.footer, props.classes?.root)}>
      <SaveButton buttonText={saveButtonText} disabled={saveDisabled} />
      <CancelButton buttonText={cancelButtonText} />
    </div>
  );
};

BasicFooter.defaultProps = {
  saveButtonText: undefined,
  saveDisabled: false,
  cancelButtonText: undefined,
};

const usePageFooterStyles = makeStyles({
  root: {
    ...shorthands.borderTop('1px', 'solid', tokens.colorNeutralStroke2),
    ...shorthands.padding('16px'),
  },
});

export const PageFooter: React.FC<BasicFooterProps> = (props) => {
  const classes = usePageFooterStyles();

  return (
    <BasicFooter
      classes={classes}
      {...props}
    />
  );
};

interface PreviewFooterProps {
  saveButtonText?: string;
  saveDisabled?: boolean;
  previewButtonText?: string;
  previewDisabled?: boolean;
  cancelButtonText?: string;
}

export const PreviewFooter: React.FC<PreviewFooterProps> = (props) => {
  const {
    saveButtonText,
    saveDisabled,
    previewButtonText,
    previewDisabled,
    cancelButtonText,
  } = props;
  const classes = useBasicFooterStyles();

  return (
    <div className={mergeClasses('preview-form-footer', classes.footer)}>
      <SaveButton buttonText={saveButtonText} disabled={saveDisabled} />
      <PreviewButton buttonText={previewButtonText} disabled={previewDisabled} />
      <CancelButton buttonText={cancelButtonText} />
    </div>
  );
};

PreviewFooter.defaultProps = {
  saveButtonText: undefined,
  saveDisabled: false,
  previewButtonText: undefined,
  previewDisabled: false,
  cancelButtonText: undefined,
};
